import { NotAuthorized } from "@/components/NotAuthorized";
import { LoadingState } from "@/components/podkit/loading/LoadingState";
import { useDocumentTitle } from "@/hooks/use-document-title";
import { useMembership } from "@/hooks/use-membership";
import { Integrations } from "@/routes/settings/organization/integrations/Integrations";
import { OrganizationRole } from "gitpod-next-api/gitpod/v1/organization_pb";
import type { FC } from "react";

export const OrgIntegrationsPage: FC = () => {
    useDocumentTitle("Integrations");

    const { membership, isPending: isLoadingMembership } = useMembership();

    if (!membership && isLoadingMembership) {
        return <LoadingState />;
    }

    if (membership?.userRole !== OrganizationRole.ADMIN) {
        return <NotAuthorized />;
    }

    return (
        <div data-testid="org-integrations-page">
            <Integrations />
        </div>
    );
};
